module.exports = __webpack_public_path__ + "media/site_templates/www.gascooktopinstallation.com.au/images/splash-e351ba607ee145d30abe9a66bb157c7e.jpg";